module.exports = __webpack_public_path__ + "static/media/officeImg7.58f63501.jpg";